<template>
    <div class="flowlu-widget">
        <div class="flowlu-widget-operations">
            <div class="flowlu-widget-operations_buttons">
                <SupsisButton @click="transferToFlowlu" primary> {{ $t("message.flowluTransfer") }} </SupsisButton>
            </div>
        </div>
    </div>
</template>
s
<script>
import SupsisButton from "../../../../views/Pages/Settings/components/SupsisButton.vue";
import { transferFlowlu } from "../../../../api/chat";

export default {
    name: "FlowluWidget",
    components: { SupsisButton },
    props: {
        contact: {
            type: Object,
            default: () => ({}),
        },
    },
    methods: {
        async transferToFlowlu() {
            const result = await transferFlowlu(this.contact.lastConversation._id).catch(() => null);
            if (!result) {
                this.$notification.error({
                    message: "Hata",
                    description: "Flowlu'ya aktarım sırasında bir hata oluştu.",
                });
                return;
            }

            this.$notification.success({
                message: "Başarılı",
                description: "Flowlu'ya aktarım başarılı.",
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.flowlu-widget {
    padding: 20px;

    &-operations {
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        &_title {
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 10px;
        }

        &_buttons {
            display: flex;
            justify-content: center;
            flex-direction: column;
        }
    }
}
</style>
